import { Serializer, SurveyModel} from "survey-core";
import { PropertyGridEditorCollection } from "survey-creator-core";

export function registerSurveyCustomDownloadProperties(): void {
  Serializer.addProperty('question', {
    name: 'fileupload',
    type: 'fileupload',
    category: 'general',
  });

  PropertyGridEditorCollection.register({
    fit: function(prop) {
      return prop.type === "fileupload";
    },
      getJSON: function(obj, prop, options) {
      return {
      type: "fileedit",
          storeDataAsText: false,
        };
    },
  });
}

export function registerSurveyCustomDownloadPropertiesTranslation(): void {
  // DO NOT LOAD in survey view-only mode, as it will throw an error because the creator chunk is not loaded
  // Dynamically import editor utils only when explicit registration is called
  import('./creator/Creator/utils-editor').then(({ registerPropertyTranslations }) => {
   registerPropertyTranslations('fileupload', {
    en: 'Upload Image/PDF',
    de: 'Bild/Pdf hochladen',
    hu: 'Kép/PDF feltöltése',
    sl: 'Naložite sliko/PDF',
    hr: 'Prenesite sliku/PDF',
    });
  }).catch(() => {
    // Gracefully handle view-only environments where creator chunk is not loaded
  });
}

export function applyCustomDownload(survey: SurveyModel, title: string): void {
  survey.onGetQuestionTitleActions.add((sender, options) => {
    const fileUrl = options.question.getPropertyValue("fileupload");
    //console.log("Applying custom download action for question:", options.question.name, "with fileUrl:", fileUrl);

    // Ensure options.actions is available and is an array before trying to push to it, quill element doesnt have it
    if (Array.isArray(options.titleActions))
    {
      // Safely check for duplicates
      const existingAction = options.titleActions.find(action => action.id === "download-link");
      if (fileUrl && !existingAction)
      {
        // Use push() to add to the array, don't overwrite it
        options.titleActions.push({
              id: "download-link",
              title: title,
              visibleIndex: 0, // Ensures it appears first
              innerCss: "sd-action-button--success", 
                action: (action) => {
                  const q = options.question;
                  window.open(fileUrl, "_blank");
                }
        });
      }
    }
  });
}